import React from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Resume from './Sicelo Sitsha CV.pdf';

const Services = () => {
  const services = [
    {
      emoji: HeartEmoji,
      heading: "Frontend engineering",
      detail:
        "React, TypeScript, responsive interfaces, accessibility, design systems, and polished UI states.",
    },
    {
      emoji: Glasses,
      heading: "Backend development",
      detail:
        "Node.js, Express, APIs, authentication, database design, integrations, and deployment workflows.",
    },
    {
      emoji: Humble,
      heading: "Product delivery",
      detail:
        "Turning requirements into usable software with clean architecture, testing habits, and maintainable code.",
    },
  ];

  return (
    <section className="services" id="services">
      <div className="section-copy">
        <span className="section-kicker">Capabilities</span>
        <h2>Full-stack execution with a neat, product-first finish.</h2>
        <p>
          I work across the stack while keeping the user experience sharp:
          useful interfaces, secure integrations, and systems that can grow.
        </p>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
      </div>
      <div className="cards">
        {services.map((service, index) => (
          <Card
            key={service.heading}
            emoji={service.emoji}
            heading={service.heading}
            detail={service.detail}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default Services;
